import React from 'react';
import { Helmet } from 'react-helmet';
import FormComponent from '../components/Form/FormComponent';

const Home = () => {
  const canonicalUrl = 'https://adobe-cid-builder.com/';

  // Keep this aligned with public/index.html so you don't emit competing descriptions.
  // (React-snap will include both the static and helmet tags in build/index.html.)
  const metaDescription =
    'Create Adobe CID tracking codes for Adobe Analytics. Use this free Adobe CID builder to standardize campaign links, confirm your cid setup, and move into governed workflows when your team is ready.';

  const ogTitle = 'Free Adobe CID Builder | Adobe Analytics CID Generator';
  const ogDescription =
    'Create Adobe CID tracking codes for Adobe Analytics. Exact-match builder page for CID searchers with a clear path to governed campaign workflows.';

  return (
    <div>
      <Helmet>
        <title>Free Adobe CID Builder | Adobe Analytics CID Generator</title>

        {/* ✅ Canonical: prevents duplicate indexing across variants */}
        <link rel="canonical" href={canonicalUrl} />

        {/* ✅ Primary meta description (aligned with public/index.html) */}
        <meta name="description" content={metaDescription} />

        {/* ✅ Indexing directives (safe defaults) */}
        <meta
          name="robots"
          content="index,follow,max-snippet:-1,max-image-preview:large,max-video-preview:-1"
        />

        {/* ✅ Open Graph (sharing + consistency) */}
        <meta property="og:title" content={ogTitle} />
        <meta property="og:description" content={ogDescription} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={canonicalUrl} />

        {/* ✅ Twitter */}
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content={ogTitle} />
        <meta name="twitter:description" content={ogDescription} />

        {/* Additional tags as required */}
      </Helmet>

      <FormComponent />
    </div>
  );
};

export default Home;